/**
 * Claim Status Constants
 * 
 * This file contains all possible claim status values used throughout the frontend application.
 * These constants should be used instead of hard-coded status strings to ensure consistency
 * and make refactoring easier. Values must match exactly with backend enum ClaimStatus.
 */

export const DRAFT = 'DRAFT';
export const SUBMITTED = 'SUBMITTED';
export const PENDING_VERIFICATION = 'PENDING_VERIFICATION';
export const VERIFICATION_FAILED = 'VERIFICATION_FAILED';
export const UNDER_REVIEW = 'UNDER_REVIEW';
export const MISSING_DOCUMENTS = 'MISSING_DOCUMENTS';
export const RECOMMENDED_FOR_APPROVAL = 'RECOMMENDED_FOR_APPROVAL';
export const APPROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
export const PAYMENT_PENDING = 'PAYMENT_PENDING';
export const PAID = 'PAID';
export const CLOSED = 'CLOSED';

// Helper object for easy access and iteration
export const CLAIM_STATUSES = {
  DRAFT,
  SUBMITTED,
  PENDING_VERIFICATION,
  VERIFICATION_FAILED,
  UNDER_REVIEW,
  MISSING_DOCUMENTS,
  RECOMMENDED_FOR_APPROVAL,
  APPROVED,
  REJECTED,
  PAYMENT_PENDING,
  PAID,
  CLOSED
};

// Status display labels for UI
export const CLAIM_STATUS_LABELS = {
  [DRAFT]: 'Draft',
  [SUBMITTED]: 'Submitted',
  [PENDING_VERIFICATION]: 'Pending Verification',
  [VERIFICATION_FAILED]: 'Verification Failed',
  [UNDER_REVIEW]: 'Under Review',
  [MISSING_DOCUMENTS]: 'Missing Documents',
  [RECOMMENDED_FOR_APPROVAL]: 'Pending Decision',
  [APPROVED]: 'Approved',
  [REJECTED]: 'Rejected',
  [PAYMENT_PENDING]: 'Payment Pending',
  [PAID]: 'Paid',
  [CLOSED]: 'Closed'
};
